import { usePaginatedQuery } from "convex/react";
import { useEffect } from "react";

/**
 * Load EVERY page of a paginated Convex query (client request 2026-10-16:
 * lists must show all rows, never "the first 500"). Each server call stays
 * bounded by pageSize; the next page is requested as soon as one arrives.
 */
export function useAllPages(query: any, args: any, pageSize = 250) {
  const { results, status, loadMore } = usePaginatedQuery(query, args, {
    initialNumItems: pageSize,
  });
  useEffect(() => {
    if (status === "CanLoadMore") loadMore(pageSize);
  }, [status, loadMore, pageSize]);
  return {
    results: results as any[],
    loading: status === "LoadingFirstPage",
    loadingMore: status === "LoadingMore" || status === "CanLoadMore",
  };
}
